import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AiExtractionRequest,
  AiExtractionResult,
} from '@intellio/shared/models';
import { map, Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class AiExtractionService extends BaseService {
  constructor() {
    super(inject(HttpClient), inject(AppConfigService), inject(AuthService));
  }

  extract(request: AiExtractionRequest): Observable<AiExtractionResult> {
    const { applicationId, fileName, ruleName } = request;
    return this.post<AiExtractionResult>('/api/agents/documents/extract', {
      applicationId,
      fileName,
      ruleName,
    }).pipe(map((response) => response.data));
  }
}
